import { parseBackendDate } from 'modules/core/components/DateNavigator/dateFormatUtils'
import BaseDayPicker from 'modules/core/components/DayPicker'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { DayOfWeekIndex, dateToString } from 'modules/core/lib/dates'

type Props = {
  date: Date
  onDateRangeChange: (startDate: Date, endDate: Date) => void
  firstDayOfWeek: DayOfWeekIndex
}

export const DayPicker = ({ date, onDateRangeChange, firstDayOfWeek }: Props) => {
  const stringDate = useUnsafeMemo(() => dateToString(date, 'backend'), [date])

  const handleOnDateRangeChange = useUnsafeCallback(
    (newDate: string) => {
      const parsedDate = parseBackendDate(newDate)

      onDateRangeChange(parsedDate, parsedDate)
    },
    [onDateRangeChange]
  )

  return (
    <BaseDayPicker
      mode="single"
      showOnlyCalendar
      valueFormat="backend"
      value={stringDate}
      onChange={handleOnDateRangeChange}
      firstDayOfWeek={firstDayOfWeek}
    />
  )
}
